<template>
  <div>
    <v-layout justify-center>
      <v-progress-circular
        v-model="loading"
        :size="70"
        :width="7"
        color="green"
        indeterminate
      ></v-progress-circular>
    </v-layout>
  </div>
</template>
<script>
export default {
  props: {
    loading: true,
  },

  data() {
    return {};
  },
};
</script>
